import { usePage } from '@inertiajs/inertia-vue3';
import _ from 'lodash';

export default function __(key, replace, locale) {
    let translation, translationNotFound = true, lang = locale ? locale : usePage().props.value.locale;
    try {
        translation = window.i18n[locale ? locale : lang][key];
        if (translation) {
            translationNotFound = false
        }
    } catch (e) {
        translation = key;

    }

    if (translationNotFound){
        translation = key
    }

    if(replace) {
        for (const [key, value] of Object.entries(replace)) {
            translation = translation.replace(':' + key, value)
        }
    }
    return translation;
}
